import App from './pt/views/App'
import Home from './pt/views/Home'
import ModelReport from './pt/views/ModelReport'
import planOptimizer from './pt/views/planOptimizer'
import planSimulator from './pt/views/planSimulator'
import SimulationDetails from './pt/views/SimulationDetails'
import Documents from './pt/views/Documents'
import WhatIfScenario from './pt/views/WhatIfScenario'
import BudgetSimulator from './pt/views/BudgetSimulator'
import BudgetSimulationDetails from './pt/views/BudgetSimulationDetails'
import adminUsers from './pt/views/adminUsers'
import adminClients from './pt/views/adminClients'
import adminReferenceModels from './pt/views/adminReferenceModels'
import adminAdHocModels from './pt/views/adminAdHocModels'
import manageCustomModels from './pt/views/manageCustomModels'
import manageEkrm from './pt/views/manageEkrm'
import modelComposer from './pt/views/modelComposer'
import automaticModels from './pt/views/automaticModels'
import manageUserModels from './pt/views/manageUserModels'
import learningCenter from './pt/views/learningCenter'
import stats from './pt/views/stats'
import adminTools from './pt/views/adminTools'
import adminPendingPlans from './pt/views/adminPendingPlans'
import adminAIReviews from './pt/views/adminAIReviews'
import adminErrorLogs from './pt/views/adminErrorLogs'
import adminNews from './pt/views/adminNews'
import adminCountries from './pt/views/adminCountries'
import InsertMap from './pt/views/InsertMap'
import playground from './pt/views/playground'
import DataUpload from './pt/views/DataUpload'
import DataCheck from './pt/views/DataCheck'
import ModelingProcess from './pt/views/ModelingProcess'
import SharedPlan from './pt/views/SharedPlan'
import SharedModelReport from './pt/views/SharedModelReport'
import ExportData from './pt/views/ExportData'

// Components translations
import components from './pt/components/index'
import AI from './pt/components/AI'
import ekrm from './pt/components/ekrm'
import simulationDetails from './pt/components/simulationDetails'
import budgetSimulator from './pt/components/budgetSimulator'
import userData from './pt/components/userData'
import dataCheck from './pt/components/dataCheck'

export default {
  views: {
    App,
    Home,
    ModelReport,
    planOptimizer,
    BudgetSimulator,
    BudgetSimulationDetails,
    planSimulator,
    SimulationDetails,
    Documents,
    WhatIfScenario,
    adminUsers,
    adminClients,
    adminReferenceModels,
    adminAdHocModels,
    manageCustomModels,
    manageEkrm,
    modelComposer,
    automaticModels,
    manageUserModels,
    learningCenter,
    stats,
    adminTools,
    adminPendingPlans,
    adminAIReviews,
    adminErrorLogs,
    adminNews,
    adminCountries,
    InsertMap,
    playground,
    DataUpload,
    DataCheck,
    ModelingProcess,
    SharedPlan,
    SharedModelReport,
    ExportData
  },
  components: {
    ...components,
    AI,
    ekrm,
    simulationDetails,
    budgetSimulator,
    userData,
    dataCheck
  }
}
